import _ from 'lodash';

import * as constants from './Events.constants';
import * as services from './Events.service';

const state = {
  Events: [],
  selectedCourseType: '',
  selectedSubCourseType: '',

  QuestionList: [],
  Question: {},
  isRequest: false,
  BeforeMockData: {},
  AfterMockData: {},
};

const mutations = {
  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },

  [constants.GET_EVENTS_SUCCESS](state, Events) {
    state.Events = Events;
  },

  [constants.SET_SELECTED_COURSE_TYPE](state, selectedCourseType) {
    state.selectedCourseType = selectedCourseType;
  },

  [constants.SET_SUB_SELECTED_COURSE_TYPE](state, selectedSubCourseType) {
    state.selectedSubCourseType = selectedSubCourseType;
  },

  [constants.SET_EVENT_STATUS](state, payload) {
    for (let i = 0, l = state.Events.length; i < l; i++) {
      const paper = state.Events[i];
      if (paper.paperId == payload.paperId) {
        paper.examStatus = payload.examStatus;
        paper.mockScore = payload.mockScore;
        paper.isParticipate = 1;
      }
    }
  },

  [constants.REDO_MOCK](state, payload) {
    const { paperId } = payload;
    state.Events = _.map(state.Events, (event) => {
      if (event.paperId === paperId) {
        return {
          ...event,
          examStatus: 2,
        };
      } else {
        return event;
      }
    });
  },

  [constants.GET_BEFORE_MOCK_SUCCESS](state, data) {
    state.BeforeMockData = data;
  },

  [constants.GET_AFTER_MOCK_SUCCESS](state, data) {
    state.AfterMockData = data;
  },

  [constants.GET_QUESTION_LIST_SUCCESS](state, list) {
    state.QuestionList = list;
  },

  [constants.GET_QUESTION_SUCCESS](state, { question, paperId }) {
    const paper = state.Events.find((v) => v.paperId == paperId);
    if (_.isEmpty(question)) {
      state.Question = question;
    } else {
      let isLatest = false;
      if (question.questionId === _.last(state.QuestionList).questionId) {
        isLatest = true;
      }
      if (paper.examStatus === 3) {
        state.Question = {
          ...question,
          isAnswered: true,
          isSubmitted: true,
          isLatest,
          selectedOption: question.studentAnswer,
        };
      } else {
        state.Question = {
          ...question,
          isAnswered: false, //question.questionType.indexOf('QA') !== -1 ? true : false,
          isLatest,
          isSubmitted: false,
          selectedOption: '',
        };
      }
      if (question.qType === 'xl') {
        const subQuestions = question.subQuestions;
        if (paper.examStatus === 3) {
          state.Question = {
            ...state.Question,
            isInSubQuestions: true,
            pos: 0,
            subQuestions: subQuestions.map((v, i) => ({
              ...v,
              isAnswered: true,
              isSubmitted: true,
              selectedOption: v.studentAnswer,
              isLatest: i === subQuestions.length - 1,
            })),
          };
        } else {
          state.Question = {
            ...state.Question,
            isInSubQuestions: true,
            pos: 0,
            subQuestions: subQuestions.map((v, i) => ({
              ...v,
              isAnswered: false, //v.questionType.indexOf('QA') !== -1 ? true : false,
              selectedOption: '',
              isSubmitted: false,
              isLatest: i === subQuestions.length - 1,
            })),
          };
        }
      }
    }
  },

  [constants.QUESTION_SUBMITTED_SUCCESS](state) {
    if (state.Question.qType !== 'xl') {
      state.Question = { ...state.Question, isSubmitted: true };
    } else {
      const subQuestions = state.Question.subQuestions;
      const question = subQuestions[state.Question.pos];
      question.isSubmitted = true;
    }
  },

  [constants.ANSWER_SUCCESS](state, payload) {
    if (state.Question.qType !== 'xl') {
      state.Question = {
        ...state.Question,
        isAnswered: true,
        selectedOption: '',
        studentAnswer: payload.studentAnswer,
      };
      const idx = _.findIndex(state.QuestionList, { questionId: state.Question.questionId });
      if (idx != -1) {
        state.QuestionList[idx].questionStatus = payload.questionStatus;
      }
    } else {
      const subQuestions = state.Question.subQuestions;
      const question = subQuestions[state.Question.pos];
      question.isAnswered = true;
      question.selectedOption = '';
      question.isCorrect = payload.questionStatus === 1 ? true : false;
      question.studentAnswer = payload.studentAnswer;
      const nonAnsweredArr = subQuestions.filter((v) => v.isAnswered === false);
      const isCorrectArr = subQuestions.filter((v) => !v.isCorrect);
      if (nonAnsweredArr.length === 0) {
        state.Question = {
          ...state.Question,
          isAnswered: true,
        };
      }
      const idx = _.findIndex(state.QuestionList, { questionId: state.Question.questionId });
      if (idx != -1 && nonAnsweredArr.length === 0) {
        if (isCorrectArr.length === 0) {
          state.QuestionList[idx].questionStatus = 1;
        } else {
          state.QuestionList[idx].questionStatus = -1;
        }
      }
    }
  },

  [constants.MARK_QUESTION_SUCCESS](state, isMarked) {
    if (state.Question.qType !== 'xl' || !state.Question.isInSubQuestions) {
      state.Question = {
        ...state.Question,
        isMarked,
      };
    } else {
      const question = state.Question.subQuestions[state.Question.pos];
      question.isMarked = isMarked;
    }
  },

  [constants.SET_QUESTION](state, payload) {
    if (state.Question.qType !== 'xl') {
      if (state.Question.noDefiniteQuestion) {
        let options = state.Question.selectedOption;
        const { selectedOption } = payload;
        options.indexOf(selectedOption) !== -1
          ? (state.Question = {
            ...state.Question,
            selectedOption: options.replace(selectedOption, ''),
          })
          : (state.Question = {
            ...state.Question,
            selectedOption: `${options}${selectedOption}`.split('').sort().join(''),
          });
      } else {
        state.Question = {
          ...state.Question,
          ...payload,
        };
      }
    } else {
      const { selectedOption } = payload;
      if (selectedOption) {
        if (state.Question.subQuestions[state.Question.pos].noDefiniteQuestion) {
          let options = state.Question.subQuestions[state.Question.pos].selectedOption;
          if (options.indexOf(selectedOption) !== -1) {
            state.Question.subQuestions[state.Question.pos].selectedOption = options.replace(
              selectedOption,
              ''
            );
          } else {
            state.Question.subQuestions[
              state.Question.pos
            ].selectedOption = `${options}${selectedOption}`.split('').sort().join('');
          }
        } else {
          state.Question.subQuestions[state.Question.pos].selectedOption = selectedOption;
        }
      } else {
        state.Question = {
          ...state.Question,
          ...payload,
        };
      }
    }
  },
};

const actions = {
  async getEvents({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getEvents(payload);
    commit(constants.GET_EVENTS_SUCCESS, res.data.data.papers);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  async getBeforeMock({ commit }, payload) {
    const res = await services.getBeforeMock(payload);
    commit(constants.GET_BEFORE_MOCK_SUCCESS, res.data.data);
  },

  async getRedoBeforeMock({ commit }, payload) {
    const res = await services.getRedoBeforeMock(payload);
    commit(constants.REDO_MOCK, payload);
    commit(constants.GET_BEFORE_MOCK_SUCCESS, res.data.data);
  },

  async getMockData({ commit }, payload) {
    const res = await services.getMockData(payload);
    if (!payload.playedVoice) {
      await services.finishVoice({ paperId: payload.paperId });
    }
    let question = {};
    if (payload.examStatus === 3) {
      question = _.head(res.data.data.list.filter((v) => v.questionStatus === 0));
    } else {
      question = _.head(res.data.data.list);
    }
    commit(constants.GET_QUESTION_LIST_SUCCESS, res.data.data.list);
    if (question) {
      const questionRes = await services.getQuestion(payload.paperId, question.questionId);
      commit(constants.GET_QUESTION_SUCCESS, {
        question: questionRes.data.data,
        paperId: payload.paperId,
      });
    } else {
      commit(constants.GET_QUESTION_SUCCESS, {});
    }
  },

  async handInPaper({ commit }, payload) {
    const res = await services.submitMock(payload);
    commit(constants.GET_AFTER_MOCK_SUCCESS, { ...payload, status: true });
    commit(constants.SET_EVENT_STATUS, {
      ...payload,
      examStatus: 3,
      mockScore: res.data.data || 0,
    });
  },

  async answer({ commit, state }, payload) {
    let param = {};
    if (state.Question.qType !== 'xl') {
      if (state.Question.questionType.indexOf('OP') !== -1) {
        param = {
          ...payload,
          questionId: state.Question.questionId,
          groupId: 0,
          studentAnswer: state.Question.selectedOption,
          questionStatus: state.Question.answer === state.Question.selectedOption ? 1 : -1,
        };
      } else if (state.Question.questionType.indexOf('QA') !== -1) {
        param = {
          ...payload,
          groupId: 0,
          questionId: state.Question.questionId,
          questionStatus: 1,
          //studentAnswer: 'done',
        };
      }
    } else {
      const question = state.Question.subQuestions[state.Question.pos];
      if (question.questionType.indexOf('OP') !== -1) {
        param = {
          ...payload,
          groupId: state.Question.questionId,
          questionId: question.questionId,
          questionStatus: question.answer === question.selectedOption ? 1 : -1,
          studentAnswer: question.selectedOption,
        };
      } else if (question.questionType.indexOf('QA') !== -1) {
        param = {
          ...payload,
          groupId: state.Question.questionId,
          questionId: question.questionId,
          questionStatus: 1,
          //studentAnswer: 'done',
        };
      }
    }
    commit(constants.ANSWER_SUCCESS, param);
    await services.answer(param);
    commit(constants.QUESTION_SUBMITTED_SUCCESS);
  },

  async getQuestion({ commit }, payload) {
    const questionRes = await services.getQuestion(payload.paperId, payload.questionId);
    commit(constants.GET_QUESTION_SUCCESS, {
      question: questionRes.data.data,
      paperId: payload.paperId,
    });
  },
};

const COURSE_TYPES = ['CFA', 'FRM', 'EEPG', 'CPA', 'ESG'];

const getters = {
  Events: (state) => state.Events,

  eventList: (state, getters) => {
    if (Array.isArray(getters.Events)) {
      const currentTime = new Date().getTime();
      return _.map(getters.Events, (event) => {
        const { courseType } = event;
        let i_courseType = '';
        let i_subCourseType = '';
        if (!courseType) {
          i_courseType = 'OTHER';
        } else {
          const arrCourseType = _.split(courseType, ' ');
          i_courseType = arrCourseType[0];
          i_subCourseType = _.join(_.drop(arrCourseType), ' ');
        }
        i_subCourseType = i_subCourseType ? i_subCourseType : 'OTHER';
        return {
          ...event,
          i_courseType,
          i_subCourseType,
          i_isCanRedoMock: event.endDate > currentTime,
        };
      });
    } else {
      return [];
    }
  },

  InProgressList: (state, getters) => {
    return _.filter(getters.eventList, (v) => v.examStatus === 2);
  },

  ReadyToStartList: (state, getters) => {
    return _.filter(getters.eventList, (v) => v.examStatus === 1);
  },

  DoneList: (state, getters) => {
    return _.filter(getters.eventList, (v) => v.examStatus === 3 && v.isParticipate == 0);
  },

  MyDoneList: (state, getters) => {
    return _.filter(getters.eventList, (v) => v.examStatus === 3 && v.isParticipate == 1);
  },

  _filterSelectedCourseType: (state) => (eventList) => {
    return _.filter(eventList, (event) => {
      if (!state.selectedCourseType) {
        return true;
      } else {
        if (event.i_courseType === state.selectedCourseType) {
          if (!state.selectedSubCourseType) {
            return true;
          } else {
            return event.i_subCourseType === state.selectedSubCourseType;
          }
        } else {
          return false;
        }
      }
    });
  },

  selectedInProgressList: (state, getters) => {
    return getters._filterSelectedCourseType(getters.InProgressList);
  },

  selectedReadyToStartList: (state, getters) => {
    return getters._filterSelectedCourseType(getters.ReadyToStartList);
  },

  selectedDoneList: (state, getters) => {
    return getters._filterSelectedCourseType(getters.DoneList);
  },

  selectedMyDoneList: (state, getters) => {
    return getters._filterSelectedCourseType(getters.MyDoneList);
  },

  courseTypes: (state, getters) => {
    let courseTypes = _.uniq(_.map(getters.eventList, (event) => event.i_courseType));
    const isHaveOther = -1 !== _.indexOf(courseTypes, 'OTHER');
    const inte = _.intersection(COURSE_TYPES, courseTypes);
    const diff = _.difference(courseTypes, [...COURSE_TYPES, 'OTHER']);
    courseTypes = [...inte, ...diff];
    courseTypes = _.reduce(
      courseTypes,
      (acc, courseType) => {
        const eventList = _.filter(getters.eventList, (event) => event.i_courseType === courseType);
        let subCourseTypes = _.uniq(_.map(eventList, (event) => event.i_subCourseType));
        const isSubHaveOther = -1 !== _.indexOf(subCourseTypes, 'OTHER');
        subCourseTypes = _.difference(subCourseTypes, ['OTHER']);
        subCourseTypes = _.sortBy(subCourseTypes, (v) => v);
        subCourseTypes = _.map(subCourseTypes, (subCourseType) => ({
          type: subCourseType,
        }));
        if (isSubHaveOther && 0 !== subCourseTypes.length) {
          const otherSubCourseType = {
            type: 'OTHER',
          };
          subCourseTypes = [...subCourseTypes, otherSubCourseType];
        }
        return [
          ...acc,
          {
            type: courseType,
            subCourseTypes,
          },
        ];
      },
      []
    );
    if (isHaveOther) {
      const otherCourseType = {
        type: 'OTHER',
        subCourseTypes: [],
      };
      courseTypes = [...courseTypes, otherCourseType];
    }
    return courseTypes;
  },

  subCourseTypes: (state, getters) => {
    if (!state.selectedCourseType) {
      return [];
    } else {
      const selectCourseType = _.find(
        getters.courseTypes,
        (courseType) => courseType.type === state.selectedCourseType
      );
      return selectCourseType.subCourseTypes;
    }
  },

  isRequest: (state) => state.isRequest,
  Question: (state) => state.Question,
  QuestionList: (state) => state.QuestionList,

  BeforeMockData: (state) => state.BeforeMockData,
  AfterMockData: (state) => state.AfterMockData,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
